import Vue from 'vue';
import groupBuyingJump from './components/groupBuyingJump';

export default () => {
    new Vue({
        el: '#app-content',
        components: {
            'group-buying-jump': groupBuyingJump
        },
        data: {},
        methods: {}
    });
};



// WEBPACK FOOTER //
// ./src/js_modules/vue/groupBuyingJump.js